import Question from "../components/questionscomponent/question";
import ForgotPassword from "../components/logincomponent/subcomponent/ForgotPassword"
import Login from "../components/logincomponent/login";
import Signup from "../components/signupcomponent/signup";
import ImpersonateLogin from "../components/impersonatelogincomponent/ImpersonateLogin";
const unProtectedRoutes = [
    {
        path: "/application/:link",
        element: <Question />
    },
    {
        path: "/reset-password/:token",
        element: <ForgotPassword />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/impersonate/login",
        element: <ImpersonateLogin />
    },
    {
        path: "/signup",
        element: <Signup />
    },
]
export default unProtectedRoutes;